import React from 'react';
import { Shield, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { CtaButton } from './CtaButton';
export function OfferBlock() {
  return <section id="offer-section" className="py-14 px-4 relative overflow-hidden" data-id="element-91">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 rounded-full blur-[150px] pointer-events-none" data-id="element-92" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <FadeIn data-id="element-94">
          <div className="relative rounded-3xl p-[1px] bg-gradient-to-b from-gold-400/60 to-gold-400/10 shadow-[0_0_50px_rgba(212,165,116,0.15)]" data-id="element-95">
            <div className="glass-card rounded-2xl p-6 md:p-10 text-center bg-navy-900/90 backdrop-blur-2xl" data-id="element-96">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-warmWhite-100 mb-4" data-id="element-97">
                Recupera tu energía, tu claridad y tu salud por menos de lo que
                cuesta una cena.
              </h2>

              <p className="text-lg text-warmWhite-200 mb-8" data-id="element-98">
                Obtén el sistema completo{' '}
                <span className="text-gold-400 font-medium" data-id="element-99">
                  "El Protocolo de Sueño Profundo"
                </span>{' '}
                hoy mismo.
              </p>

              <div className="mb-8" data-id="element-100">
                <div className="flex items-center justify-center gap-4 mb-2" data-id="element-101">
                  <span className="text-2xl text-warmWhite-200/50 line-through decoration-red-400/50 decoration-2" data-id="element-102">
                    $63.99 USD
                  </span>
                  <ArrowRight className="w-5 h-5 text-gold-400" data-id="element-103" />
                </div>
                <div className="text-5xl md:text-6xl font-heading font-bold text-gold-400 drop-shadow-[0_0_15px_rgba(212,165,116,0.3)]" data-id="element-104">
                  $9.36 <span className="text-3xl" data-id="element-105">USD</span>
                </div>
              </div>

              <div className="flex flex-col items-center gap-4" data-id="element-106">
                <CtaButton text="¡Sí, quiero volver a dormir bien!" subtitle="Comprar Ahora!" className="w-full md:w-auto md:px-12 md:py-5 md:text-xl" data-id="element-107" />

                <div className="flex items-center gap-2 text-sm text-warmWhite-200/80" data-id="element-108">
                  <Shield className="w-4 h-4 text-green-400/80" data-id="element-109" />
                  <span data-id="element-110">
                    Pago seguro y acceso inmediato para que empieces esta misma
                    noche
                  </span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}